var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-data-table',{attrs:{"loading":_vm.gridLoading,"items":_vm.userTimesheets,"headers":_vm.headers,"search":_vm.search,"group-by":"name"},on:{"click:row":_vm.rowClick},scopedSlots:_vm._u([{key:"group.header",fn:function(ref){
var items = ref.items;
return [_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v(_vm._s(items[0].name))])])]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.status),"dark":""}},[_vm._v(_vm._s(item.status))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }